import { apiRequest } from './api';
import { TELEGRAM } from './endPoints';
import { TELEGRAM_COMPONENT } from '../constants/component';

// --------------------------
// BOT CONFIG APIS
// --------------------------

export const GET_TELEGRAM_BOT_CONFIGS = (page = 0, limit = 10) => {
  const params = { page, limit };
  return apiRequest('get', TELEGRAM.FETCH_BOT_CONFIGS(), null, params, TELEGRAM_COMPONENT);
};

export const ADD_TELEGRAM_BOT_CONFIG = (token) => {
  return apiRequest('post', TELEGRAM.ADD_BOT_CONFIG(), { token }, null, TELEGRAM_COMPONENT);
};

// --------------------------
// CONTACTS APIS
// --------------------------

export const GET_TELEGRAM_CONTACTS = (botConfigId, page = 0, limit = 10, globalFilter) => {
  const params = { page, limit };

  // Filters
  if (globalFilter) {
    params.global = globalFilter;
  }

  return apiRequest('get', TELEGRAM.FETCH_CONTACTS(botConfigId), null, params, TELEGRAM_COMPONENT);
};

// --------------------------
// MESSAGES APIS
// --------------------------

export const GET_TELEGRAM_MESSAGES = (botConfigId, chatId, lastMessageId = 0, limit = 10) => {
  const params = { lastMessageId, limit };
  return apiRequest(
    'get',
    TELEGRAM.FETCH_MESSAGES(botConfigId, chatId),
    null,
    params,
    TELEGRAM_COMPONENT,
  );
};

export const SEND_TELEGRAM_MESSAGE = (botConfigId, payload) => {
  return apiRequest(
    'post',
    TELEGRAM.SEND_MESSAGE(botConfigId, payload.message.chat_id),
    payload,
    null,
    TELEGRAM_COMPONENT,
  );
};

export const POST_RESET_UNREAD_COUNT = (botConfigId, chatId) => {
  return apiRequest(
    'post',
    TELEGRAM.RESET_UNREAD_COUNTS(botConfigId, chatId),
    null,
    null,
    TELEGRAM_COMPONENT,
  );
};
